<template>
  <e-charts
    ref="line"
    autoresize
    :options="option"
    theme="theme-color"
    auto-resize
    @rendered="updateSliderRangeCursor"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/chart/line'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
    sliderRangeCursor: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.$nextTick(this.updateSliderRangeCursor)
  },
  methods: {
    updateSliderRangeCursor() {
      if (!this.sliderRangeCursor) return

      const chart = this.getChartInstance()
      if (!chart || !chart.getModel || !chart.getViewOfComponentModel) return

      chart.getModel().eachComponent('dataZoom', model => {
        if (model.subType !== 'slider') return

        const view = chart.getViewOfComponentModel(model)
        // eslint-disable-next-line no-underscore-dangle
        const displayables = view && view._displayables
        const filler = displayables && displayables.filler
        if (filler && filler.cursor !== this.sliderRangeCursor) {
          filler.attr('cursor', this.sliderRangeCursor)
        }
      })
    },
    getChartInstance() {
      if (this.$refs.line) {
        return this.$refs.line.chart || this.$refs.line
      }
      return null
    },
  },
  data() {
    return {
      option: {
        animation: this.optionData.animation,
        tooltip: this.optionData.tooltip || {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        legend: this.optionData.legend || { left: 0 },
        grid: this.optionData.grid,
        xAxis: this.optionData.xAxis,
        yAxis: this.optionData.yAxis,
        series: this.optionData.series,
        dataZoom: this.optionData.dataZoom,
      },
    }
  },
}
</script>

<style>
.echarts {
  width: 100% !important;
}
</style>
